import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResidentService {
  public patientId: number;
  public pharmacyId: number;
  public facilityId: number;
  private ApiUrl = "";
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.ApiUrl = baseUrl;
  }


  getResidentProfile(): Observable<any[]> {
    return this.http.get<any>(this.ApiUrl + 'api/resident/GetResidentProfile/' + this.pharmacyId + '/' + this.patientId);
  }

  getResidentProfileFor(pharmacyId: number, patientId: number): Observable<any> {
    return this.http.get<any>(this.ApiUrl + 'api/resident/GetResidentProfile/' + pharmacyId + '/' + patientId);
  }

  getResidentsByFilters(pharmacyId, facilityId, facilityUnitId, patientId, inactive): Observable<any[]> {
    return this.http.get<any>(this.ApiUrl + 'api/resident/GetResidentsByFilters/' + pharmacyId + '/' + facilityId + '/' + facilityUnitId + '/' + patientId + '/' + inactive);
  }
}
